import React from "react";
import bgHomeS4 from "../../assets/landingPage/bg-home-s4.png";

export default function MystioSectionNew() {
  return (
    <section
      id="mystio"
      className="w-full py-24 px-4 md:px-8 lg:px-16  bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgHomeS4})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center justify-center">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-oswald text-white tracking-widest uppercase mb-8 leading-tight">
          MYSTIO GLOBAL LOGISTICS – <span className="text-secondary">MOVING THE WORLD FORWARD</span>
        </h2>

        {/* Divider lines decoration */}
        <div className="flex items-center justify-center gap-3 w-40 mb-8">
          <div className="h-[1px] bg-secondary/30 flex-1"></div>
          <div className="w-2 h-2 rounded-full bg-secondary"></div>
          <div className="h-[1px] bg-secondary/30 flex-1"></div>
        </div>

        {/* Paragraph */}
        <p className="text-gray-300 font-outfit text-base md:text-lg lg:text-xl leading-relaxed max-w-3xl">
          Mystio Global Logistics provides fast, reliable, and intelligent delivery solutions for creators, retailers, and consumers. From local dispatch to nationwide retail distribution, Mystio ensures your products move with precision, speed, and transparency.
        </p>
      </div>
    </section>
  );
}
